import { Redirect } from 'react-router-dom'
import { useAuthStatus } from '@mwxltd/flix-api-client'
import { useWizardState } from '../subscriptions/useWizardState'

export const ifSubscribedGoTo = (redirectPath) => (Component) => (props) => {
  const { subscribed } = useAuthStatus()
  return subscribed ? <Redirect to={redirectPath} /> : <Component {...props} />
}

export const ifNotSubscribedGoTo = (redirectPath) => (Component) => (props) => {
  const { subscribed } = useAuthStatus()
  return !subscribed ? <Redirect to={redirectPath} /> : <Component {...props} />
}

export const ifVerifiedGoTo = (redirectPath) => (Component) => (props) => {
  const { emailVerified } = useAuthStatus()
  return emailVerified ? <Redirect to={redirectPath} /> : <Component {...props} />
}

export const ifNotChosenPlanGoTo = (redirectPath) => (Component) => (props) => {
  const { chosenPlan } = useWizardState()
  return !chosenPlan ? <Redirect to={redirectPath} /> : <Component {...props} />
}
